import React from "react";
import "./AboutDescription.css";

const AboutDescription = ({ value }) => {
  
  return (
    <div className="mb-5 mx-auto container row m-0 text-center justify-content-center pb-2 aboutUsPageImageSection">
      {/* <div className="col-4"> */}
      {value !== undefined &&
        value.map((data, index) => (
          <div
            key={index}
            className="col-12 col-sm-6 col-md-4 col-lg-4 mt-2 mb-2 "
          >
            <img src={data.image} alt={data?.imageAlt} className="img-fluid" />
            <h4 className="imgTitle text-center mt-2 mb-2">
              {data.heading}
              {/* {data.heading.split(" ").slice(0, 4).join(" ")}
              <br />
              {data.heading.split(" ").slice(4).join(" ")} */}
            </h4>
          </div>
        ))}
    </div>
    // </div>
  );
};

export default React.memo(AboutDescription);
